module.exports = __webpack_public_path__ + "media/character-grandpa-content.f919f8ed.mp3";